var Modal = require('../modalUtilities');
var initPaypalButton = require('/cartridges/custom_paypal/cartridge/client/default/js/cart/paypal/initMinicartButton');
var base = require('../product/base');
const { appendToUrl } = require('../common/urlUtil');
const { validateBasket, updateCartTotals, updateProductsTotalAndSubtotal } = require('../cart/common');
var done = false;

function liveChatEnable() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'block',
        visibility: 'visible'
    });
};

function liveChatDiseble() {
    $('.helpButton, #embeddedMessagingConversationButton').css({
        display: 'none',
        visibility: 'hidden'
    });
};

/**
 * re-renders the order totals and the number of items in the cart
 * @param {Object} message - Error message to display
 */
function createErrorNotification(message) {
    var errorHtml = '<div class="alert alert-danger alert-dismissible valid-cart-error ' +
        'fade show" role="alert">' +
        '<button type="button" class="close" data-dismiss="alert" aria-label="Close">' +
        '<span aria-hidden="true">&times;</span>' +
        '</button>' + message + '</div>';

    $('.cart-error').append(errorHtml);
}

/**
 * re-renders the approaching discount messages
 * @param {Object} approachingDiscounts - updated approaching discounts for the cart
 */
function updateApproachingDiscounts(approachingDiscounts) {
    var html = '';
    $('.approaching-discounts').empty();
    if (approachingDiscounts.length > 0) {
        approachingDiscounts.forEach(function (item) {
            html += '<div class="single-approaching-discount text-center">'
                + item.discountMsg + '</div>';
        });
    }
    $('.approaching-discounts').append(html);
}

/**
 * Updates the availability of a product line item
 * @param {Object} data - AJAX response from the server
 * @param {string} uuid - The uuid of the product line item to update
 */
function updateAvailability(data, uuid) {
    var lineItem;
    var messages = '';

    for (var i = 0; i < data.items.length; i++) {
        if (data.items[i].UUID === uuid) {
            lineItem = data.items[i];
            break;
        }
    }

    $('.js-availability-' + lineItem.UUID).empty();

    if (lineItem.availability) {
        if (lineItem.availability.messages) {
            lineItem.availability.messages.forEach(function (message) {
                messages += '<p class="line-item-attributes">' + message + '</p>';
            });
        }

        if (lineItem.availability.inStockDate) {
            messages += '<p class="line-item-attributes line-item-instock-date">'
                + lineItem.availability.inStockDate
                + '</p>';
        }
    }

    $('.js-availability-' + lineItem.UUID).html(messages);
}

function liveChatDisableAndFixScrolling() {
    liveChatDiseble();
    var heightFooter = $('.cc-minicart-footer').height();
    $('.cc-minicart-content').css({ 'padding-bottom': heightFooter });
}

function injectPaypalSDK() {
    var head = document.getElementsByTagName('head').item(0);
    var script = document.createElement('script');
    script.async = true;
    script.type = 'text/javascript';
    script.onload = function () {
        initPaypalButton.initPaypalButton();
    };
    script.src = window.paypalUrls.cartSdkUrl;
    script.setAttribute('data-partner-attribution-id', window.paypalUrls.partnerAttributionId);
    head.appendChild(script);
}

function initPaypal() {
    if ($('#js-paypal-minicart-enabled').val() === 'true') {
        const paypalUrls = document.querySelector('.js_paypal-content').getAttribute('data-paypal-urls');
        window.paypalUrls = JSON.parse(paypalUrls);
        window.paypal ? initPaypalButton.initPaypalButton() : injectPaypalSDK();
        done = true;
    }
}

module.exports = function () {
    var temporized;

    // open modal on click to minicart
    $('body').on('click', '.js-minicart-button', function (e) {
        e.preventDefault();
        let modalTarget = e.currentTarget.dataset.target;
        let modal = new Modal(modalTarget, { onShow: liveChatDisableAndFixScrolling, onClose: liveChatEnable });
        $(document).find('.js-minicartside-overlay-container').css('content-visibility', 'visible');
        $(modalTarget).attr('aria-hidden', 'false');
        modal.open();
        if (!done) {
            initPaypal();
        }
        clearTimeout(temporized);

        var heightFooter = $('.cc-minicart-footer').height();
        var widthContent = $('.cc-minicart-pcard').width();
        $('.cc-minicart-content').css({ 'padding-bottom': heightFooter });
        $('.cc-minicart-footer').css({ width: widthContent });
    });

    // open modal after on addToCart
    $('body').on('product:afterAddToCart', function (e) {
        e.preventDefault();

        clearTimeout(temporized);

        var url = $('.add-to-minicart-url').val();
        var isCart = $(document).find('.cc-cart');
        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                $('.js-minicart-quantity').empty().append(data.numItems);
                $('.js-minicart-numofitems').empty().append(data.resources.minicartNumberOfItems);
                $('.js-grand-total').empty().append(data.totals.grandTotal);
                $('.js-minicart-pcard').empty().append(data.miniCartSide);
                if (isCart.length === 0) {
                    let modalTarget = $('.js-minicart-button').data('target');
                    let modal = new Modal(modalTarget, { onShow: liveChatDisableAndFixScrolling, onClose: liveChatEnable });
                    $(document).find('.js-minicartside-overlay-container').css('content-visibility', 'visible');
                    modal.open();
                    temporized = setTimeout(function () {
                        modal.close();
                    }, 5000);
                    if (!done) {
                        initPaypal();
                    }
                }
                $('#minicart-overlay').attr('aria-hidden', 'false');
                $.spinner().stop();
                var widthContent = $('.cc-minicart-pcard').width();
                if (!$('body').hasClass('cc-desktop')) {
                    widthContent += 15;
                }
                $('.cc-minicart-footer').css({ width: widthContent });
                var heightFooter = $('.cc-minicart-footer').height();
                $('.cc-minicart-content').css({ 'padding-bottom': heightFooter });
                if (isCart.length > 0) {
                    $.spinner().start();
                }
            },
            error: function (err) {
                if (err.responseJSON) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                } else {
                    $.spinner().stop();
                }
            }
        });
    });

    // temporize minicart side
    $('body').on('mouseleave', '.js-minicartside-overlay-container', function(e) {
        e.preventDefault();

        let modalTarget = $('.js-minicart-button').data('target');
        let modal = new Modal(modalTarget, { onShow: liveChatDisableAndFixScrolling, onClose: liveChatEnable });
        if ($(modalTarget).hasClass('cc-open')) {
            modal._open = true;
        }
        temporized = setTimeout(function () {
            modal.close();
        }, 5000);
    });

    // clear temporized minicart side
    $('body').on('mouseenter', '.js-minicartside-overlay-container', function(e) {
        e.preventDefault();
        clearTimeout(temporized);
    });

    // close modal onclick
    $('body').on('click', '.js-close', function(e) {
        e.preventDefault();
        clearTimeout(temporized);
        let modalTarget = $('.js-minicart-button').data('target');
        let modal = new Modal(modalTarget, { onShow: liveChatDisableAndFixScrolling, onClose: liveChatEnable });
        modal.close();
    });

    // goes to cart page
    $('body').on('click', '.js-gotocart, .js-go-to-cart-mobile', function (e) {
        e.preventDefault();
        var action = $(this).data('action');
        window.location.href = action;
        $.spinner().start();
    });

    $('body').on('click', '.js-remove-btn-minicart', function (e) {
        e.preventDefault();

        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var fromWhere = $(this).data('from');
        var currentProductUUID = $(this).data('uuid');
        var urlParams = {
            pid: productID,
            uuid: uuid
        };

        url = appendToUrl(url, urlParams);

        $.spinner().start();
        $.ajax({
            url: url,
            type: 'get',
            dataType: 'json',
            success: function (data) {
                // analytics
                var prodQuantity;
                var selector;
                if (fromWhere === 'minicart') {
                    prodQuantity = $('.js-remove-quantity-analytics-minicart-' + uuid).text();
                    selector = '.js-pcard .js-analytics-click-product-info-' + productID;
                } else {
                    prodQuantity = $('.js-remove-quantity-analytics-cart-' + uuid).text();
                    selector = '.js-item .js-analytics-click-product-info-' + productID;
                }

                $('body').trigger('analytics:pushRemoveFromCart', {selector: selector, quantity: prodQuantity, from: fromWhere, oncomplete: function(selector){
                    $(selector).remove();
                } });

                // Accessibility: announce that the product has been removed
                var srProdRemovedMessage = $('input[name="sr-minicart-product-removed-' + currentProductUUID + '"]').val();
                $('#sr-minicart-product-removed').text(srProdRemovedMessage);

                if (data.toBeDeletedUUIDs && data.toBeDeletedUUIDs.length > 0) {
                    for (var i = 0; i < data.toBeDeletedUUIDs.length; i++) {
                        $('.js-uuid-' + data.toBeDeletedUUIDs[i]).remove();
                    }
                }

                $('.js-uuid-' + uuid).remove();

                if (!data.basket.hasBonusProduct) {
                    $('.bonus-product').remove();
                }

                $('.js-coupon-err-container').empty().append(data.basket.totals.discountsHtml);
                updateCartTotals(data.basket);
                updateApproachingDiscounts(data.basket.approachingDiscounts);
                validateBasket(data.basket);

                $('body').trigger('cart:update');

                // update checkout summary
                if (data.checkoutSummaryHtml.length) {
                    $('.cc-checkout-summary').replaceWith(data.checkoutSummaryHtml);
                }

                // update sticky summary
                if (data.grandTotalHtml) {
                    $('.js-sticky-totalSummary').replaceWith(data.grandTotalHtml);
                }


                $.spinner().stop();
            },
            error: function (err) {
                if (err.responseJSON) {
                    if (err.responseJSON.redirectUrl) {
                        window.location.href = err.responseJSON.redirectUrl;
                    }
                } else {
                    createErrorNotification(err.responseJSON.errorMessage);
                    $.spinner().stop();
                }
            }
        });
    });
    $(document).on('click', '.js-change-quantity', function (e) {
        e.stopImmediatePropagation();
        var productID = $(this).data('pid');
        var url = $(this).data('action');
        var uuid = $(this).data('uuid');
        var fromWhere = $(this).data('from');

        var itemQuantity = $('.js-item-quantity-' + uuid);
        var quantity = itemQuantity.data('quantity');
        var minQuantity = itemQuantity.data('min');
        var maxQuantity = itemQuantity.data('max');
        var type = $(this).data('type');
        var disabled = $(this).hasClass('disabled');

        if (!disabled) {
            var urlParams = {
                pid: productID,
                quantity: quantity,
                uuid: uuid,
                type: type
            };
            url = appendToUrl(url, urlParams);

            $.spinner().start();

            $.ajax({
                url: url,
                type: 'get',
                context: this,
                dataType: 'json',
                success: function (data) {
                    var newQuantity = 0;

                    var selector;
                    if (fromWhere === 'minicart') {
                        prodQuantity = $('.js-remove-quantity-analytics-minicart-' + uuid).text();
                        selector = '.js-pcard .js-analytics-click-product-info-' + productID;;
                    } else {
                        prodQuantity = $('.js-remove-quantity-analytics-cart-' + uuid).text();
                        selector = '.js-item .js-analytics-click-product-info-' + productID;
                    }

                    if (type === 'up') {
                        newQuantity = quantity + 1;
                        if ($('.js-down-quantity-' + uuid).hasClass('disabled')) {
                            $('.js-down-quantity-' + uuid).each(function() {
                                $(this).removeClass('disabled').prop('disabled', false);
                            });
                        }

                        if (newQuantity === maxQuantity) {
                            $('.js-up-quantity-' + uuid).each(function() {
                                $(this).addClass('disabled').prop('disabled', true);
                            });
                        }
                    } else if (type === 'down') {
                        newQuantity = quantity - 1;
                        if ($('.js-up-quantity-' + uuid).hasClass('disabled')) {
                            $('.js-up-quantity-' + uuid).each(function() {
                                $(this).removeClass('disabled').prop('disabled', false);
                            });
                        }

                        if (newQuantity === minQuantity) {
                            $('.js-down-quantity-' + uuid).each(function() {
                                $(this).addClass('disabled').prop('disabled', true);
                            });
                        }
                    }

                    $('body').trigger('analytics:pushChangeQuantity', {selector: selector, type: type, from: fromWhere});

                    itemQuantity.empty().append(newQuantity);
                    itemQuantity.data('quantity', newQuantity);
                    $('.js-coupon-err-container').empty().append(data.totals.discountsHtml);
                    data.uuid = uuid;
                    updateCartTotals(data);
                    updateProductsTotalAndSubtotal(data);
                    updateApproachingDiscounts(data.approachingDiscounts);
                    updateAvailability(data, uuid);
                    validateBasket(data);

                    $('body').trigger('cart:update');

                    let $container = $('.js-quantity-update-accessibility-container');
                    let text = $container.data('label');
                    let items = data.items;
                    let productName = items.filter((e) => { return e.UUID === uuid; })[0].productName;
                    $container.html(text.replace('{0}', productName).replace('{1}', newQuantity)).show();

                    // update checkout summary
                    if (data.checkoutSummaryHtml.length) {
                        $('.cc-checkout-summary').replaceWith(data.checkoutSummaryHtml);
                    }
                    // update sticky summary
                    if (data.grandTotalHtml) {
                        $('.js-sticky-totalSummary').replaceWith(data.grandTotalHtml);
                    }

                    $.spinner().stop();
                    /* if ($(this).parents('.product-info').hasClass('bonus-product-line-item') && $('.cart-page').length) {
                        location.reload();
                    } */
                },
                error: function (err) {
                    if (err.responseJSON) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        }
                    } else {
                        createErrorNotification(err.responseJSON.errorMessage);
                        $(this).val(parseInt(quantity, 10));
                        $.spinner().stop();
                    }
                }
            });
        }
    });

    base.selectAttribute();
    base.colorAttribute();
};
